import { string } from "prop-types"
import internal from "stream";

export const COMPANY_NAME = "Nigon Foods";
export const SUPPORT_MOBILE_NUMBER = "9736464123";

export interface User {
    id: number;
    name: string;
    loginName: string;
    email: string;
    password: string;
}

export interface Party {
    id: number;
    name: string;
    contactPerson: string;
    searchName: string;
    mobileNumber: string;
    groupName: string;
    type: string;
    groupId: number;
    category: string;
    accountType: string;
    email: string;
    code: string;
    registrationType: string;
    gstin: string;
    pan: string;
    billingAddress1: string;
    billingAddress2: string;
    billingCity: string;
    billingStateCode: number;
    billingPinCode: string;
    shippingAddress1: string;
    shippingAddress2: string;
    shippingCity: string;
    shippingStateCode: number;
    shippingPinCode: string;
    openingBalance: number;
    openingBalanceAsOn: string;
    createdBy: number;
    isExpanded?: boolean;
    accountId: number;
  }

export interface Transaction {
    closingBalance: number;
    credit: number;
    debit: number;
    description: string;
    openingBalance: number;
    transactionRefNumber: number;
    transactionType: string;
    voucherId: number;
    voucherNumber: string;
    voucherType: string;
    transactionDate: string;
}

export interface BusinessSummaryModel {
    openingBalance: number;
    sales: number;
    creditNote: number;
    return: number;
    receipt: number;
    journal: number;
    business: number;
    closingBalance: number;
    newBalance: number;
    oldBalance: number;
    partyName: string;
    mobile: string;
    address: string;
    contact: string;
}

export interface PendingInvoices {
    voucherDate: string;
    paymentDate: string;
    voucherNumber: string;
    billAmount: number;
    paidAmount: number;
    pendingAmount: number;
    dueDays: number;
    isSelected?: boolean;
}

export interface SalesPerson {
    id: number;
    name: string;
    mobileNumber: string;
    isActive: boolean;
}

export interface Sale {
    id: number;
    voucherNumber: string;
    date: string;
    party: Party;
    status: number;
    billAmount: number;
    pendingAmount: number;
    deliveryData: DispatchDetails;
    isExpanded: boolean;
    items: OrderItem[];
    receipts: Receipt[];
}

export interface SaleOrder {
    id: number;
    voucherNumber: string;
    date: string;
    party: Party;
    billAmount: number;
    deliveryData: DispatchDetails;
    isExpanded: boolean;
    status: number;
    statsDisplay: string;
    receipts: Receipt[];
}

export interface CreditNote {
    id: number;
    voucherNumber: string;
    date: string;
    party: Party;
    amount: number;
    notes: string;
    isExpanded: boolean;
}

export class Receipt {
    series: string;
    transactionType: string;
    voucherNumber: string;
    referenceNumber: string;
    id: number;
    saleId: number;
    date: string;
    partyId: number;
    partyName: string;
    departmentId: number;
    accountId: number;
    amount: number;
    notes: string;
    paymentType: string;
    receiptAccountId: number;
    incomeAccountId: number;
    party: Party;
    account: Account;
    incomeAccount: Account;
    allocations: Allocation[];
    isExpanded: boolean;
  }

  export interface Account {
    id: number
    name: string
  }
  
  export interface Allocation {
    saleId: number
    amount: number
    saleVoucherNumber: string
  }

export interface VoucherSummary {
    numberOfInvoices: number;
    billAmount: number;
}

export interface DispatchDetails {
    dispatchedThrough: string,
    vehicleNumber: string,
    driverName: string,
    driverNumber: string
}

export interface ProductGroup {
    id: number;
    name: string;
    code: string;
    imageUrl: string;
}


export interface Product {
    discount: number;
    groupName: string;
    id: number,
    imageUrl: string;
    name: string;
    price: number;
    taxPercentage: number;
    unit: string;
    code: string;
}

export class SaleOrder {
    id: number;
    voucherNumber: string;
    date: string;
    dueDate: string;
    departmentId: number;
    series: string;
    party: Party;
    shippingAddress1: string;
    shippingAddress2: string;
    shippingCity: string;
    shippingPinCode: string;
    shippingStateCode: number;
    supplyStateId: number;
    notes: string;
    items: OrderItem[];
    taxableValue: number;
    discount: number;
    cgstTax: number;
    sgstTax: number;
    igstTax: number;
    netValue: number;
    roundOff: number;
    billAmount: number;
    status: number;
    isApproved: boolean;
    isExpanded: boolean;
    documents: OrderDocument[];

    constructor() {
        this.items = [];
        this.documents = [];
        this.status = 5;
        this.departmentId  = 1;
        this.supplyStateId = 29;
        this.shippingStateCode = 29;
        this.isApproved = false;
    }
}

export class OrderItem {
    product: Product;
    quantity: number;
    taxableValue: number;
    discount: number;
    cgstTax: number;
    sgstTax: number;
    igstTax: number;
    netValue: number;
}

export class OrderDocument {
    id: number;
    voucherId: number;
    name: string;
    notes: string;
    fileUrl: string;
    uploadedAt: string;
}